require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-glennsl-rebug.json") })
        }
      }, "path---package-glennsl-rebug");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-glennsl-rebug!./.cache/json/package-glennsl-rebug.json
// module id = 867
// module chunks = 231608221292675